export default __webpack_public_path__ + "static/media/iconTrashBlue.9a58c704.svg";